var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import clsx from 'clsx';
import { HawkinsProvider, useClasses, useLayoutProps, useProps } from '@hawkins/helpers';
import { usePaperStyles } from './paper.styles';
/**
 * Conditional wrapper to wrap the Paper inner in a `HawkinsProvider` or not based on the theme prop
 */
var ConditionalWrapper = function (_a) {
    var condition = _a.condition, wrapper = _a.wrapper, children = _a.children;
    return (condition ? wrapper(children) : children);
};
var displayName = 'Paper';
/**
 * The Paper component, separate so that we can wrap it in a `HawkinsProvider` if needed
 */
export var PaperInner = function (props) {
    var _a;
    var className = props.className, square = props.square, forwardedRef = props.forwardedRef, children = props.children, _b = props.elevation, elevation = _b === void 0 ? 0 : _b, classesProp = props.classes, _c = props.component, Component = _c === void 0 ? 'div' : _c, layout = props.layout, styleProp = props.style, rest = __rest(props, ["className", "square", "forwardedRef", "children", "elevation", "classes", "component", "layout", "style"]);
    var baseClasses = usePaperStyles();
    var classes = useClasses(displayName, baseClasses, classesProp);
    var style = useLayoutProps({ layout: layout, style: styleProp });
    var paperClassName = clsx(classes.HAWKINS_BASE, classes.root, className, (_a = {},
        _a[classes.rounded] = !square,
        _a[classes.square] = square,
        _a[classes.elevation0] = elevation === 0,
        _a[classes.elevation1] = elevation === 1,
        _a[classes.elevation2] = elevation === 2,
        _a));
    return (_jsx(Component, __assign({}, rest, { className: paperClassName, ref: forwardedRef, style: style }, { children: children })));
};
PaperInner.displayName = 'PaperInner';
/**
 * A paper element that is theme aware and has elevation
 */
export var Paper = React.forwardRef(function (props, ref) {
    var _a = useProps(displayName, props), _b = _a.component, component = _b === void 0 ? 'div' : _b, theme = _a.theme, rest = __rest(_a, ["component", "theme"]);
    return (_jsx(ConditionalWrapper, __assign({ condition: theme === 'light' || theme === 'dark', wrapper: function (children) { return (_jsx(HawkinsProvider, __assign({ theme: theme, includeCssReset: false }, { children: children }))); } }, { children: _jsx(PaperInner, __assign({}, rest, { component: component, forwardedRef: ref })) })));
});
Paper.displayName = displayName;
